import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

interface MetaHelmetProps {
  title?: string;
  desc?: string;
  img_url?: string;
  seo_title?: string;
  og_type?: string;
  noindex?: boolean;
}

const MetaHelmet: React.FC<MetaHelmetProps> = ({
  title = 'smartGastro',
  desc = 'Finde über 1000 Gastro-Betriebe in Graz! Restaurants, Bars, Cafés sowie Events, entdecke versteckte Schätze und exklusive Berichte auf smartGastro.',
  img_url = 'https://smartgastro.at/images/sG_fallback_small.jpeg',
  seo_title,
  og_type = 'website',
  noindex = false,
}) => {
  const location = useLocation();
  const fullLinkUrl = `${window.location.origin}${location.pathname}`;

  const fullTitle = title ? `${title} | smartGastro` : 'smartGastro | Dein Gastroguide in Graz';
  const metaTitle = seo_title ? `${seo_title}` : fullTitle;
  const robotsContent = noindex ? 'noindex, nofollow' : 'index, follow';

  return (
    <Helmet>
      <link rel="canonical" href={fullLinkUrl} />
      <title>{metaTitle}</title>
      <meta name="title" content={metaTitle} />
      <meta name="description" content={desc} />
      <meta name="robots" content={robotsContent} />

      <meta property="og:type" content={og_type} />
      <meta property="og:url" content={fullLinkUrl} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img_url} />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullLinkUrl} />
      <meta property="twitter:title" content={metaTitle} />
      <meta property="twitter:description" content={desc} />
      <meta property="twitter:image" content={img_url} />
    </Helmet>
  );
};

export default MetaHelmet;
